import { UrlHelper } from 'utilities/UrlHelper/UrlHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

define((require, exports, module) => {
    'use strict';

    const _ = require('lodash');
    const keyBy = require('utils/keyBy');
    const compactObject = require('utils/compactObject');
    const fixPhone = require('system/libs/fixPhone');
    const defs = require('./Registration.defs');
    const RPCModel = require('RPCModel');

    const defaults = {
        id: 0,
    };

    /**
     * Организационно-правовая форма.
     * @type {string}
     */
    defaults[defs.LEGAL_FORM] = '';

    /**
     * ИНН
     * @type {string}
     */
    defaults[defs.INN] = '';

    /**
     * ОРГН
     * @type {string}
     */
    defaults[defs.OGRN] = '';

    /**
     * Название организации.
     * @type {string}
     */
    defaults[defs.LEGAL_NAME] = '';

    /**
     * Телефон.
     * @type {string}
     */
    defaults[defs.PHONE] = '';

    /**
     * Физический адрес.
     * @type {string}
     */
    defaults[defs.PHYSICAL_ADDRESS] = '';

    /**
     * КПП
     * @type {string}
     */
    defaults[defs.KPP] = '';

    /**
     * Юридический почтовый индекс.
     * @type {string}
     */
    defaults[defs.LEGAL_POST] = '';

    /**
     * Юридический город.
     * @type {string}
     */
    defaults[defs.LEGAL_CITY] = '';

    /**
     * Юридическая улица.
     * @type {string}
     */
    defaults[defs.LEGAL_STREET] = '';

    /**
     * Юридический дом.
     * @type {string}
     */
    defaults[defs.LEGAL_HOUSE] = '';

    /**
     * Юридический регион.
     * @type {string}
     */
    defaults[defs.LEGAL_REGION] = '';

    const Registration = RPCModel.extend({
        className: 'MCS.Billing.Registration',

        findOneUrl: 'projects/:pid/billing/moreinfo',

        saveUrl(params) {
            const legalForm = params[defs.LEGAL_FORM];
            let url;

            switch (legalForm) {
                case defs.TYPE_INDIVIDUAL:
                case defs.TYPE_LEGAL:
                    url = 'projects/:pid/billing/registration/' + legalForm;

                    break;

                default:
                    throw new Error('Model Registration.saveUrl: no legalForm');
            }

            return url;
        },

        autofillUrl: 'projects/:pid/billing/registration',

        defaults,

        valueValidator(value, key) {
            if (key === 'phone') {
                value = fixPhone(value);
            }

            return value;
        },

        parse(body) {
            return Object.assign(
                {
                    id: body.id,
                    legal_form: body.legal_form || 'unknown',
                },
                body.extra,
            );
        },

        prepareSendData(method, attrs) {
            const legalForm = this.get(defs.LEGAL_FORM);
            const data = this.toJSON();

            attrs = {
                id: 0,
            };

            if (legalForm === defs.TYPE_INDIVIDUAL) {
                attrs[defs.INN] = data[defs.INN];
                attrs[defs.OGRN] = data[defs.OGRN];
                attrs[defs.LEGAL_NAME] = data[defs.LEGAL_NAME];
                attrs[defs.PHONE] = data[defs.PHONE];
                attrs.physical_address = data.physical_address;
            } else if (legalForm === defs.TYPE_LEGAL) {
                attrs[defs.INN] = data[defs.INN];
                attrs[defs.KPP] = data[defs.KPP];
                attrs[defs.OGRN] = data[defs.OGRN];
                attrs[defs.LEGAL_NAME] = data[defs.LEGAL_NAME];
                attrs[defs.PHONE] = data[defs.PHONE];
                attrs[defs.LEGAL_POST] = data[defs.LEGAL_POST];
                attrs[defs.LEGAL_CITY] = data[defs.LEGAL_CITY];
                attrs[defs.LEGAL_STREET] = data[defs.LEGAL_STREET];
                attrs[defs.LEGAL_HOUSE] = data[defs.LEGAL_HOUSE];
                attrs[defs.LEGAL_REGION] = String(data[defs.LEGAL_REGION]);
            }

            return method === 'save' ? { registration_info: attrs } : attrs;
        },

        prepareRequisite(requisite) {
            const attrs = {};
            let legalAddress;
            let city;
            let house;

            attrs[defs.INN] = requisite.inn;
            attrs[defs.OGRN] = requisite.ogrn;

            const ul = requisite.UL;
            const ip = requisite.IP;

            if (ul) {
                attrs[defs.LEGAL_FORM] = defs.TYPE_LEGAL;
                attrs[defs.KPP] = ul.kpp;
                attrs[defs.LEGAL_NAME] = _.get(ul, 'legalName.full');

                legalAddress = _.get(ul, 'legalAddress.parsedAddressRF');

                if (legalAddress) {
                    attrs[defs.LEGAL_POST] = legalAddress.zipCode;
                    attrs[defs.LEGAL_REGION] = legalAddress.regionCode;

                    // берём либо город либо населённый пункт либо имя региона
                    city =
                        _.get(legalAddress, 'city.topoValue') ||
                        _.get(legalAddress, 'settlement.topoValue') ||
                        _.get(legalAddress, 'regionName.topoValue');

                    attrs[defs.LEGAL_CITY] = city;
                    attrs[defs.LEGAL_STREET] = _.get(
                        legalAddress,
                        'street.topoValue',
                    );

                    if (legalAddress.bulk) {
                        // склеиваем строку вида "33, к 2"
                        house = [
                            _.get(legalAddress, 'house.topoValue'),
                            ', ',
                            _.get(legalAddress, 'bulk.topoShortName'),
                            ' ',
                            _.get(legalAddress, 'bulk.topoValue'),
                        ].join('');
                    } else {
                        house = _.get(legalAddress, 'house.topoValue');
                    }

                    attrs[defs.LEGAL_HOUSE] = house;
                }
            } else {
                attrs[defs.LEGAL_FORM] = defs.TYPE_INDIVIDUAL;
                attrs[defs.LEGAL_NAME] = ip.fio;
            }

            return compactObject(attrs);
        },

        _autofill(requisite) {
            const data = this.prepareRequisite(requisite);

            this.set(data);
        },

        autofill(ogrn) {
            const requisite = this._requisites[ogrn];

            this._autofill(requisite);
        },

        fetchLegalRequisites() {
            return this.queue((model) => {
                const params = {};

                params[defs.LEGAL_FORM] = model.get(defs.LEGAL_FORM);
                params[defs.INN] = model.get(defs.INN);

                return model.request
                    .get(Registration.url('autofill'), params)
                    .then((requisites) => {
                        requisites = _.get(requisites, 'body', []);

                        model._requisites = keyBy(requisites, 'ogrn');

                        return requisites;
                    });
            });
        },

        fetchMoreInfo() {
            return this.queue((model) => {
                return model.request
                    .get(Registration.url('findOne'))
                    .then((response) => {
                        return _.get(response, 'body', []);
                    });
            });
        },

        getLegalType() {
            return this.get(defs.LEGAL_FORM);
        },

        reset(attrs) {
            const resetedState = _.assign({}, this.defaults, attrs);

            this.set(resetedState);

            return this;
        },
    });

    Registration.url = function(name, params) {
        const url =
            (name === 'save'
                ? this.fn[name + 'Url'](params)
                : this.fn[name + 'Url']) || this.fn.url;

        const pid = BoundCurrentUserSelectors.getPid();

        return UrlHelper.moveParamsToUrlWithSideEffect({
            url,
            params: { pid, ...params },
        });
    };

    module.exports = Registration;
});
